//imports
import { all } from 'redux-saga/effects';

//Views
import createEditSimProviderSagas from 'Modules/simProviders/views/.components/createEditSimProvider/redux/saga';
import deleteSimProviderSagas from 'Modules/simProviders/views/.components/deleteSimProvider/redux/saga';
//merge sagas
export default function* rootSaga() {
    yield all([
        createEditSimProviderSagas(),
        deleteSimProviderSagas(),
    ]);
}